import { useContext } from "react"
import Card from "../ui-elements/Card"
import { GlobalContext } from "../GlobalContext"

type Props = {
}

function NoActiveCheckPeriods({
}: Props) {

    const { t } = useContext(GlobalContext)

    return <div className={`animate-fadein w-full mt-2`}>
        <Card fullwidth={true}>
            <div className={` w-full flex flex-col gap-1 items-center justify-center`}>
                <p className={`text-4xl`}>🏆</p>
                <h4 className={`font-righteous text-brandblue text-2xl`}>{t('NoActiveCheckPeriods.heading')}</h4>
                <p className={`text-lg`}>{t("NoActiveCheckPeriods.subheading")}</p>
            </div>
        </Card>
    </div>
}
export default NoActiveCheckPeriods